import React, { useCallback } from 'react'
import Popup from 'reactjs-popup'
import styled from 'particles/themes/styled'
import { theme } from 'theme'
import Button from './Button/Button'
import CloseButton from './Button/CloseButton'

interface ConfirmationModalProps {
    mainIcon?: React.ReactElement
    children?: React.ReactNode
    confirmText?: string
    cancelText?: string
    open: boolean
    toggle: VoidFunction
    onConfirm: VoidFunction
    onCancel?: VoidFunction
    allowClickOutside?: boolean
    width?: string
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    children,
    mainIcon,
    open,
    toggle,
    onConfirm,
    onCancel,
    confirmText = 'Yes',
    cancelText = 'No',
    allowClickOutside = false,
    width = '571px',
}) => {
    const handleCancelButtonClick = useCallback(() => {
        if (onCancel) onCancel()
        toggle()
    }, [onCancel])

    return (
        <StyledModal open={open} closeOnDocumentClick={allowClickOutside} width={width} closeOnEscape={false}>
            <div>
                <CloseButton size={24} color={theme.newColors.neutral700} className="close-button" onClick={toggle} />
                {mainIcon ? <div className="main-icon">{React.cloneElement(mainIcon)}</div> : undefined}
                {children}
                <div className="button-actions">
                    <Button
                        type="button"
                        size="l"
                        buttonType="secondary"
                        onClick={handleCancelButtonClick}
                        text={cancelText}
                    ></Button>
                    <Button type="button" size="l" buttonType="primary" onClick={onConfirm} text={confirmText}></Button>
                </div>
            </div>
        </StyledModal>
    )
}

const StyledModal = styled(Popup)<{ width?: string }>`
    &-content {
        width: ${props => (props.width ? props.width : '50%')}!important;
        background: ${theme.newColors.neutral50};

        box-shadow:
            0px 8px 10px -5px rgba(0, 0, 0, 0.2),
            0px 16px 24px 2px rgba(0, 0, 0, 0.14),
            0px 6px 30px 5px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        padding: ${theme.newSpacing.l} !important;
        box-sizing: border-box;

        & > div {
            & .close-button {
                position: absolute;
                top: ${theme.newSpacing.m};
                right: ${theme.newSpacing.m};
            }

            & .main-icon {
                display: flex;
                justify-content: center;
                // margin-botom: ${theme.newSpacing.l};
            }

            & .button-actions {
                margin-top: ${theme.newSpacing.l};
                display: flex;
                justify-content: center;
                gap: ${theme.newSpacing.l};
            }
        }
    }
`

export default ConfirmationModal
